import React, { useCallback, useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import LayoutWithOutAccountCard from '../Layout/layout-without-card'
import ApprovalService from '../../services/approval.service'
import Loading from 'custom/assets/loaders/Loading'
import DownloadIcon from 'custom/assets/common-icons/Download.svg'
import SIDetails from '../../components/view-details/si'
import SIHeaderDetails from '../../components/header-details/si'
import ApprovePageDetails from '../../components/page-separation-details/historyapprovepagenation'
import RejectPageDetails from '../../components/page-separation-details/historyrejectpagenation'
import {HISTORY_COMMON_KEYS} from "../../utils/translation-constants"
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux'
import { getMenuListSelector } from '../../store/selectors/app.selector'

export default function HistorySI() {
  const history = useHistory()
  const [stage, setStage] = useState(1)
  const [noRecords, setNoRecords] = useState(false)
  const [dataSource, setDataSource] = useState([])
  const [approvedList, setApprovedList] = useState([])
  const [rejectedList, setRejectedList] = useState([])
  const [loading, setLoading] = useState(false)
  const [expanded, setExpanded] = useState(null)
  const [minValue, setMinValue] = useState(0)
  const [maxValue, setMaxValue] = useState(5)
  const {t}=useTranslation()
  const menuConfig = useSelector(getMenuListSelector)['HISTORY'] || {}

  useEffect(() => {
    getDataSourceList()
  }, [])

  const getDataSourceList = useCallback(async () => {
    try {
      setLoading(true)
      const response = await ApprovalService.getSIList({ listType: 'AUTHORIZED' })
      if (response.status === 200) {
        setLoading(false)
        setStage(1)
        setNoRecords(response.data['siCreateRequestList']?.length > 0 ? false : true)
        setApprovedList(
          response.data['siCreateRequestList'].filter((ele) => ele.authStatus === 'A'),
        )
        setRejectedList(
          response.data['siCreateRequestList'].filter((ele) => ele.authStatus === 'R'),
        )
      }
    } catch (err) {
      setLoading(false)
    }
  }, [])

  const onDownload = useCallback(async () => {
    try {
      await ApprovalService.SIDownload({ listType: 'AUTHORIZED' })
    } catch (err) {
      setLoading(false)
    }
  }, [])

  const resetFields = useCallback(() => {
    setExpanded(null)
    setMaxValue(5)
    setMinValue(0)
  }, [])

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }

  function renderSwitch() {
    switch (stage) {
      case 1:
        return renderApprovedList()
      case 2:
        return renderRejectedList()
      default:
        return renderApprovedList()
    }
  }

  function renderApprovedList() {
    return (
      <>
        {approvedList.length === 0 && <div className='no-data-found'>{t(HISTORY_COMMON_KEYS.NO_RECORDS_FOUND)} </div>}
        <RenderList dataSource={approvedList} />

        {approvedList.length > 5 && (
          <div>
            <ApprovePageDetails
              defaultPageSize={5}
              setMaxValue={(value) => {
                setExpanded(null)
                setMaxValue(value)
              }}
              setMinValue={(value) => setMinValue(value)}
              totalLength={approvedList.length}
              defaultCurrent={1}
            />
          </div>
        )}
      </>
    )
  }

  function renderRejectedList() {
    return (
      <>
        {rejectedList.length === 0 && <div className='no-data-found'>{t(HISTORY_COMMON_KEYS.NO_RECORDS_FOUND)} </div>}
        <RenderList dataSource={rejectedList} />
        {rejectedList.length > 5 && (
          <div>
            <RejectPageDetails
              defaultPageSize={5}
              setMaxValue={(value) => {
                setExpanded(null)
                setMaxValue(value)
              }}
              setMinValue={(value) => setMinValue(value)}
              totalLength={rejectedList.length}
              defaultCurrent={1}
            />
          </div>
        )}
      </>
    )
  }

  function RenderList({ dataSource = [] }) {
    return (
      <>
        {dataSource.slice(minValue, maxValue).map((option, index) => (
          <div key={index} className='approval-card'>
            <div
              className=' '
              onClick={() => (expanded == index ? setExpanded(null) : setExpanded(index))}>
              <SIHeaderDetails option={option} />
            </div>

            {expanded === index && (
              <div className='approval-card-body'>
                <SIDetails option={option} />
              </div>
            )}
          </div>
        ))}
      </>
    )
  }

  return (
    <LayoutWithOutAccountCard
      keyPath={'HISTORY'}
      showEmptySpace={true}
      breadCumKey='HISTORY_SI'>
      <div
        className='d-flex'
        style={{ justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <div className='heading-style' style={{ margin: 0 }}>
        {t(HISTORY_COMMON_KEYS.SI_TITLE)}
        </div>
        {menuConfig["SI"] && (
        <button
          tabIndex={'1'}
          type='button'
          onClick={() => onDownload()}
          className='btn detailed-statement-btn'
          style={{ padding: '5px 25px' }}>
          <img src={DownloadIcon} alt='' className='mr-2' height={23} width={20} />
          <span className='font-weight-600'>{t(HISTORY_COMMON_KEYS.DOWNLOAD)}</span>
        </button>
        )}
      </div>
      <div className='row tab-navbar tab-navbar1'>
        <div className={stage === 1 ? 'col-6 selected' : 'col-6'}>
          <span
            onClick={() => {
              setStage(1)
              resetFields()
            }}>
            {t(HISTORY_COMMON_KEYS.APPROVED)}
          </span>
        </div>
        <div className={stage === 2 ? 'col-6 selected' : 'col-6'}>
          <span
            onClick={() => {
              setStage(2)
              resetFields()
            }}>
            {t(HISTORY_COMMON_KEYS.REJECT)}
          </span>
        </div>
      </div>
      {loading && renderLoading()}
      {/* {noRecords && <div className='no-data-found'>No Records Found </div>} */}
      {!loading && renderSwitch()}
    </LayoutWithOutAccountCard>
  )
}
